export default function () {
    return function (value) {
        return !isNaN((new Date(value)).getTime());
    }
}
